import React from 'react';
import styled from 'styled-components';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../context/ProductBuilder/machine';
import { getFormatedPrice } from '../../../helpers/getFormatedPrice';
import { getProductType } from '../../../helpers/getProductType';
import { getBaseProductType } from '../../../helpers/getBaseProductType';
import { ProductWithMeasurements } from '../../../types';
import { Button } from '../../Common/Button';
// import { AddtoCart } from '../../Icon';
import { TWindow } from '../../../types';
import { ProductSummaryModel } from '../ProductSummaryModal/ProductSummaryModal';
import { Breakdown } from '../Breakdown';

const Summary_detail = styled.div``;
const Summary_detail_wrapper = styled.div``;
const Summary_product_detail = styled.div`
  padding: 32px 32px;
  background: #F8F8F8;

  @media (max-width: 1440px) {
    padding: 32px 25px;
  }

  @media (max-width: 767px) {
    padding: 30px 16px;
  }
`;
const Summary_title = styled.div`
  h4 {
    font-size: calc(var(--bs-h4) - 1px);
    font-weight: var(--weight-bold);
    margin-bottom: 20px;
  }
`;
const Summary_product_detail_wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;

  ul {
    column-count: 2;
    list-style: none;
    flex: 0 0 72%;
    margin-top: 0;
    padding:0;
  }

  li {
    display: flex;
    margin: 0 -5px 12px;
    flex-wrap: wrap;
    align-items: center;
    break-inside: avoid;
  }

  li span {
    flex: 0 0 50%;
    margin: 0;
    color: var(--bs-text);
    padding: 0px 5px;
  }

  @media (max-width: 1440px) {
    li {
      margin: 0 -5px 3px;
    }
    li span {
      font-size: var(--bs-xs-font-size);
      flex: 0 0 49%;	
    }
  }
  @media (min-width: 768px) and (max-width: 1023px) {
    li span {
      flex-wrap: wrap;
    }
  }
  @media (max-width: 767px) {
    ul {
       column-count: 1;
       list-style: none;
       flex: 0 0 100%;
       margin-top: 0px;
    }
   }
`;

const Summary_total = styled.div`
  flex: 0 0 28%;

  @media (max-width: 767px) {
    flex: 0 0 100%;
  }
`;

const Summary_total_wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;
const Summary_total_price = styled.h6`
  font-weight: var(--bs-font-weight);
`;

export const SummaryWrapper = () => {
  const [state, send] = useService(productBuilderMachine);
  const {
    custom,
    productWithMeasurements,
    wandblack,
    wandwhite,
  } = state.context;
  const summaryProductType = getProductType(state.context);
  const productType = getBaseProductType(state.context);
  const _window = window as TWindow;

  let dayNightBracketsPrice = 0;
  if (_window.dayNightBrackets !== undefined && window.location.pathname.includes('roller-day-night')) {
    dayNightBracketsPrice = _window.dayNightBrackets[0].first_available_variant.price;
  }

  let displayPrice = 0;
  let measureInsurancePrice = (custom.measureInsurancePrice || 0) as number;
  let fasciaPrice = (custom.fasciaPrice || 0) as number;
  let smartReleasePrice = (custom.smartReleasePrice || 0) as number;
  let lightGuardPrice = (custom.lightGuardPrice || 0) as number;
  let honeycombVerticalCentreOpeningSurchargePrice = (custom.honeycombVerticalCentreOpeningSurchargePrice ||
    0) as number;
  let venetianValancePrice = (custom.venetianValancePrice || 0) as number;
  let trackPrice = (custom.trackPrice || 0) as number;
  let extensionPolePrice = (custom.extensionPolePrice || 0) as number;
  let stainlessSteelChainPrice = (custom.stainlessSteelChainPrice ||
    0) as number;

  // Calculate wand colour price dynamically from variant data
  const getWandColourPrice = () => {
    // Don't charge for wand if wand_option is "No"
    if (custom.wand_option === "No") return 0;

    // Use stored price if available, otherwise calculate from variant data
    if (custom.wand_colour_price && custom.wand_colour_price > 0) {
     
      return custom.wand_colour_price;
    }

    if (!custom.wand_colour || custom.wand_colour === "no") return 0;

    const selectedWand = custom.wand_colour?.toLowerCase().includes("white") ? wandwhite : wandblack;
    if (selectedWand?.[0]?.variants?.[0]) {
    
      return selectedWand[0].variants[0].price;
    }
    return 0;
  };

  let wandColourPrice = getWandColourPrice();
  let trackColourPrice = (custom.track_colour_price || 0) as number;
  let liningColourPrice = (custom.lining_colour_price || 0) as number;

  // Fix dual track pricing: Use track colour price if available, otherwise use basic track price
  if (trackColourPrice > 0) {
    
    trackPrice = 0; // Zero out basic track price since track colour price includes it
   
  }
  let highestPrice = 0;

  // Validate that productWithMeasurements is a valid object (not an error string)
  const isValidProductWithMeasurements = 
    productWithMeasurements !== null && 
    typeof productWithMeasurements !== 'string' && 
    productWithMeasurements.data && 
    Array.isArray(productWithMeasurements.data);

  if (
    isValidProductWithMeasurements &&
    productWithMeasurements!.data.length > 1
  ) {
    const airFreight = productWithMeasurements!.data.filter(
      (product: ProductWithMeasurements) =>
        product.attributes.freight === 'air',
    );
    highestPrice = parseFloat(airFreight[0].attributes.price) * 100;
    // Check if this is a curtain type that should NOT have double pricing
    const isCurtain = state.context.products[0]?.type === 'Curtain';
    
  
    
    highestPrice =
      custom.configuration && custom.configuration.includes('Centre Opening') && !isCurtain
        ? highestPrice * 2
        : highestPrice;
    highestPrice =
      window.location.pathname.includes('roller-day-night')
        ? highestPrice + (parseFloat(airFreight[1].attributes.price) * 100) + dayNightBracketsPrice
        : highestPrice;
  } else if (
    isValidProductWithMeasurements &&
    productWithMeasurements!.data.length === 1
  ) {
    highestPrice =
      parseFloat(productWithMeasurements!.data[0].attributes.price) * 100;
    // Check if this is a curtain type that should NOT have double pricing
    const isCurtain = state.context.products[0]?.type === 'Curtain';
    
 
    
    highestPrice =
      custom.configuration && custom.configuration.includes('Centre Opening') && !isCurtain
        ? highestPrice * 2
        : highestPrice;
    highestPrice =
      window.location.pathname.includes('roller-day-night')
        ? highestPrice + (parseFloat(productWithMeasurements!.data[1].attributes.price) * 100) + dayNightBracketsPrice
        : highestPrice;
  }

  let blindPrice =
    custom.dynamicPrice > 0
      ? ((custom.dynamicPrice * 100) as number)
      : highestPrice;
  
  function calculateDiscountedPrice(originalPrice: number, discountPercentage: number) {
    const discountAmount = originalPrice * (discountPercentage / 100);
    const discountedPrice = originalPrice - discountAmount;
    return discountedPrice * 100;
  }

  // For curtains, only show price when productWithMeasurements is available to prevent random addon prices
  // For other products, show price normally (same logic as ToolBar)
  const isCurtain = state.context.products[0]?.type === "Curtain";
  const shouldShowPrice = isCurtain ? isValidProductWithMeasurements : true;

  displayPrice = shouldShowPrice ? 
    measureInsurancePrice +
    fasciaPrice +
    smartReleasePrice +
    lightGuardPrice +
    venetianValancePrice +
    trackPrice +
    extensionPolePrice +
    stainlessSteelChainPrice +
    honeycombVerticalCentreOpeningSurchargePrice +
    wandColourPrice +
    trackColourPrice +
    liningColourPrice +
    blindPrice : 0;

  let discountedPrice = shouldShowPrice ?
    measureInsurancePrice +
    fasciaPrice +
    smartReleasePrice +
    lightGuardPrice +
    venetianValancePrice +
    trackPrice +
    extensionPolePrice +
    stainlessSteelChainPrice +
    honeycombVerticalCentreOpeningSurchargePrice +
    wandColourPrice +
    trackColourPrice +
    liningColourPrice +
    ((custom as any).colourDiscoutCode && (custom as any).colourDiscoutCode !== "" && !isNaN(parseInt((custom as any).colourDiscoutCode)) && parseInt((custom as any).colourDiscoutCode) > 0
      ? calculateDiscountedPrice((blindPrice / 100), parseInt((custom as any).colourDiscoutCode))
      : blindPrice) : 0;

  return (
    <>
      {/* {state.matches('complete') && (
        <StyledAddtoCartRibbon>
          <StyledProductPriceWrapper>
            Total Price {displayPrice ? getFormatedPrice((displayPrice / 100).toString()) : "0.00"}
          </StyledProductPriceWrapper>
          <Button
            onClick={() => {
              send({ type: 'ADD_TO_CART' });
            }}
            disabled={
              state.event.type === 'ADD_TO_CART' ||
              state.event.type ===
                'done.invoke.productBuilder.complete.loading:invocation[0]'
            }
          >
            <span>
              <AddtoCart />
            </span>
            <span>Add to cart</span>
          </Button>
        </StyledAddtoCartRibbon>
      )} */}
      <Summary_detail>
        <Summary_detail_wrapper>
          <Summary_product_detail>
            <Summary_title>
              <ProductSummaryModel
                productType={
                  summaryProductType
                    ? summaryProductType
                    : productType
                      ? productType
                      : ''
                } />
            </Summary_title>
            <Summary_product_detail_wrapper>
              <Breakdown />
              <Summary_total>
                <Summary_total_wrapper>
                  <Summary_total_price>Total Price</Summary_total_price>
                  <div>
                    {(custom as any).colourDiscoutCode && (custom as any).colourDiscoutCode !== "" && !isNaN(parseInt((custom as any).colourDiscoutCode)) && parseInt((custom as any).colourDiscoutCode) > 0 ? (
                      <>
                        <h6 style={{ textDecoration: "line-through", margin: 0 }}>{displayPrice ? getFormatedPrice((displayPrice / 100).toString()) : "$0.00"}</h6>
                        <h6>{discountedPrice ? getFormatedPrice((discountedPrice / 100).toString()) : "$0.00"}</h6>
                      </>
                    ) : (
                      <h6>{displayPrice ? getFormatedPrice((displayPrice / 100).toString()) : "$0.00"}</h6>
                    )}
                  </div>
                </Summary_total_wrapper>
                <Button
                  onClick={() => {
                    send({ type: 'ADD_TO_CART' });
                  }}
                  disabled={
                    state.event.type === 'ADD_TO_CART' ||
                    state.event.type ===
                    'done.invoke.productBuilder.complete.loading:invocation[0]' ||
                    state.event.type !== 'COMPLETE'
                  }>
                  Add to cart
                </Button>
              </Summary_total>
            </Summary_product_detail_wrapper>
          </Summary_product_detail>
        </Summary_detail_wrapper>
      </Summary_detail>
    </>
  );
};
